module.exports = __webpack_public_path__ + "img/2.5077d7f9.png";